<template>
  <v-dialog v-model="show" persistent  max-width="50%">
    <v-card>
      <v-card-text>
        Processing {{ `${loaded} / ${uploadData}` }}...Please wait
        <v-progress-linear
          indeterminate
          class="mb-0"
        ></v-progress-linear>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "ProcessLoader",
  data() {
      return{
          show:false
      }  
  },
  props: {
    loaded: {
      type: Number,
      required: true,
    },
    uploadData: {
      type: Number,
      required: true,
    },
  },
};
</script>
<style scoped>
.v-card__text {
  padding-top: 15px !important;
}
</style>